import { apiClient } from './config'

export const POST_TYPES = {
  REQUEST: 'REQUEST',
  JOB: 'JOB',
  SERVICE: 'SERVICE',
}

export const POST_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
  REMOVED: 'REMOVED',
}

export const postsService = {
  async getPosts(params = {}) {
    const { 
      type, 
      categoryId, 
      city, 
      status, 
      authorId, 
      q, 
      page = 1, 
      limit = 20,
      sort,
      order 
    } = params
    
    const queryParams = new URLSearchParams()
    
    if (type) queryParams.append('type', type)
    if (categoryId) queryParams.append('categoryId', categoryId)
    if (city) queryParams.append('city', city)
    if (status) queryParams.append('status', status)
    if (authorId) queryParams.append('authorId', authorId)
    if (q) queryParams.append('q', q)
    if (sort) queryParams.append('sort', sort)
    if (order) queryParams.append('order', order)
    queryParams.append('page', page)
    queryParams.append('limit', limit)
    
    return apiClient.get(`/posts?${queryParams.toString()}`)
  },

  async getRequests(params = {}) {
    return this.getPosts({ ...params, type: POST_TYPES.REQUEST })
  },

  async getJobs(params = {}) {
    return this.getPosts({ ...params, type: POST_TYPES.JOB })
  },

  async getServices(params = {}) {
    return this.getPosts({ ...params, type: POST_TYPES.SERVICE })
  },

  async getPostById(id) {
    return apiClient.get(`/posts/${id}`)
  },

  async createPost(data) {
    return apiClient.post('/posts', data)
  },

  async createRequest(data) {
    return this.createPost({ ...data, type: POST_TYPES.REQUEST })
  },

  async createJob(data) {
    return this.createPost({ ...data, type: POST_TYPES.JOB })
  },

  async createService(data) {
    return this.createPost({ ...data, type: POST_TYPES.SERVICE })
  },

  async updatePost(id, data) {
    return apiClient.patch(`/posts/${id}`, data)
  },

  async deletePost(id) {
    return apiClient.delete(`/posts/${id}`)
  },

  async recordView(id) {
    return apiClient.post(`/posts/${id}/view`)
  },

  async searchPosts(q, params = {}) {
    const { type, page = 1, limit = 20 } = params
    const queryParams = new URLSearchParams()
    
    queryParams.append('q', q)
    if (type) queryParams.append('type', type)
    queryParams.append('page', page)
    queryParams.append('limit', limit)
    
    return apiClient.get(`/posts/search?${queryParams.toString()}`)
  },

  async getMyRequests(params = {}) {
    const user = JSON.parse(localStorage.getItem('proconnect_user') || '{}')
    return this.getRequests({ ...params, authorId: user.id })
  },

  async getMyJobs(params = {}) {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return this.getJobs({ ...params, authorId: user.id })
  },
}
